"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var client_1 = require("@apollo/client");
var moment_1 = __importDefault(require("moment"));
var index_1 = __importDefault(require("../../index"));
var InquiryDrawerContent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var query = _a.query, queryVariablesFormatter = _a.queryVariablesFormatter, queryVariables = _a.queryVariables;
    var _j = client_1.useQuery(query, {
        variables: queryVariablesFormatter
            ? queryVariablesFormatter(queryVariables)
            : queryVariables,
    }), loading = _j.loading, data = _j.data;
    // todo if loading show spinner inside drawer
    if (loading || !data) {
        return (react_1.default.createElement("div", { style: { top: "50%", left: "50%", position: "absolute" } },
            react_1.default.createElement(antd_1.Space, { size: "middle" },
                react_1.default.createElement(antd_1.Spin, { size: "large", tip: "Loading..." }))));
    }
    return (react_1.default.createElement(antd_1.Row, null,
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Inquiry ID"),
            react_1.default.createElement("br", null),
            " ",
            ((_b = data.inquiry) === null || _b === void 0 ? void 0 : _b.id) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Reporter"),
            react_1.default.createElement("br", null),
            " ",
            ((_c = data.inquiry) === null || _c === void 0 ? void 0 : _c.name) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Priority"),
            react_1.default.createElement("br", null),
            " ",
            ((_d = data.inquiry) === null || _d === void 0 ? void 0 : _d.priority) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Case Type"),
            react_1.default.createElement("br", null),
            " ",
            ((_e = data.inquiry) === null || _e === void 0 ? void 0 : _e.issueType) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "deadline"),
            react_1.default.createElement("br", null),
            " ",
            moment_1.default((_f = data.inquiry) === null || _f === void 0 ? void 0 : _f.deadline).format("LLL") || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Comment"),
            react_1.default.createElement("br", null),
            " ",
            ((_g = data.inquiry) === null || _g === void 0 ? void 0 : _g.description) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Estimated Waste Volume"),
            react_1.default.createElement("br", null),
            " ",
            ((_h = data.inquiry) === null || _h === void 0 ? void 0 : _h.wasteVolume) || "")));
};
var InquiryDrawer = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, restProps = __rest(_a, ["visible", "onClose"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_1.default, { visible: visible, onClose: onClose, title: "Inquiry" },
            react_1.default.createElement(InquiryDrawerContent, __assign({}, restProps)))));
};
exports.default = InquiryDrawer;
